import { useQueryClient } from '@tanstack/react-query';
import { useMutation } from 'query';
import { changeRequest } from 'features/change-requests';
import { getProgramQueryKey } from '../keys';

/**
 * @deprecated Move this query into the change-requests feature. It belongs next to `changeRequest`, not under programs.
 */
export const useCreateRequestToJoinMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<
    undefined,
    {
      data: { reason: string };
      programId: string;
    }
  >({
    async mutationFn({ data, programId }) {
      await changeRequest({
        body: {
          kind: 'program_request_to_join',
          meta: {
            reason_to_join: data.reason,
          },
          subject_id: programId,
          subject_type: 'Program',
        },
      });

      return undefined;
    },
    onSuccess(_data, { programId }) {
      void queryClient.invalidateQueries({ queryKey: getProgramQueryKey({ programId }) });
    },
  });
};
